import React from 'react';
import { useRouter } from 'next/router';
import { useDispatch, useSelector } from 'react-redux';
import cn from 'classnames';
import { Icon, RouterLink } from 'src/components';
import { isDesktopSelector, pageSelector } from 'src/selectors/app';
import * as ContentActions from 'src/redux/actions/content';
import { IAppPage, IContent } from 'src/interface';
import { useTracking } from 'src/hooks/useTracking';
import { UrlUtils } from 'src/utils';

interface IProps {
    content: IContent;
}

export default React.memo(function ContentsHistoryItem({ content }: IProps) {
    const isDesktop = useSelector(isDesktopSelector);
    const dispatch = useDispatch();
    const page: IAppPage = useSelector(pageSelector);
    const router = useRouter();
    const tracking = 'detail|suggest_next';
    const trackingRef = useTracking(content.contentId, tracking);

    const onClick = (evt: React.MouseEvent) => {
        evt.preventDefault();
        evt.stopPropagation();

        (window as any)._BM.sourceTracking = tracking;

        if (isDesktop) {
            window.open(content.redirectUrl, '_blank');
        } else {
            const { utmSource, utmId } = (window as any)._BM;
            if (utmId === 'web_install_ads' && utmSource) {
                const link = `https://baomoi.onelink.me/Dfp0?pid=${utmSource}&c=web_install_ads&af_dp=baomoi%3A%2F%2Fcontent%3Fsource%3Dweb_install_ads%26contentId%3D${content.contentId}&deep_link_value=baomoi%3A%2F%2Fcontent%3Fsource%3Dweb_install_ads%26contentId%3D${content.contentId}`;
                router.push(link);
                return;
            }
            if (UrlUtils.isContentDetailPage(page.type)) {
                router.push(content.url);
            } else {
                content.tracking = tracking;
                dispatch(ContentActions.openContent(content));
                const _window: any = window;
                if (_window.AdtimaBaomoi && _window.AdtimaBaomoi.config) {
                    _window.AdtimaBaomoi.config._reqid = 0;
                }

                //track to web api (theo dõi xong xóa)
                // TrackingUtils.tracking(API_URL + '/log/post', {
                //     type: 'tracking',
                //     value: 'suggest_next',
                // });
            }
        }
    };

    return (
        <RouterLink
            className={cn(
                'block',
                'text-[2.2rem] font-medium leading-[1.25]',
                'pb-[20px]'
            )}
            to={content.url}
            onClick={onClick}
            ref={trackingRef}
        >
            <Icon
                className={cn('text-[1.4rem]', 'mr-[12px]')}
                icon="angles-right"
            ></Icon>
            {content.title}
        </RouterLink>
    );
});
